import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Menu } from 'antd';
import { logout as logoutThunk, selectActiveUser } from 'shared/store/auth-slice';
import { showSetupSteps, showTipsAndUsage, startTour } from 'shared/store/tour-slice';
import { useAppDispatch, useAppSelector } from 'shared/store';
import UserAvatar from 'shared/components/UserAvatar';
import { NavHoverMenu } from '../NavHoverMenu';
import './style.less';
import { TourStepId } from 'shared/utils/tour';

export const NavBarUser = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectActiveUser);
  const hasCheckedUser = useAppSelector(s => s.auth.hasCheckedUser);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const hiddenSetupSteps = !useAppSelector(s => s.tour.showSetupSteps);
  const hiddenTipsUsage = !useAppSelector(s => s.tour.showTipsAndUsage);

  const openMenu = () => {
    setIsMenuOpen(true);
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const logout = () => {
    dispatch(logoutThunk());
  };

  const handleStartTour = () => {
    dispatch(startTour());
  };

  if (!hasCheckedUser) {
    return null;
  }

  return (
    <button
      onClick={() => history.push('/settings/account')}
      className="NavBarUser"
      onMouseOver={openMenu}
      onMouseLeave={closeMenu}
      onFocus={openMenu}
      onBlur={closeMenu}
      tabIndex={0}
    >
      <UserAvatar className="NavBarUser__avatar" user={user} size={46} />
      <NavHoverMenu isOpen={isMenuOpen} bottom={20}>
        <Menu selectedKeys={[]}>
          <Menu.Item onClick={handleStartTour}>
            <Link
              to={`/?tourStep=${TourStepId.Start}`}
              className="NavBarUser__menu-header-link"
            >
              📚 Take a tour
            </Link>
          </Menu.Item>
          {hiddenSetupSteps && (
            <Menu.Item>
              <Link
                onClick={e => {
                  e.stopPropagation();
                  dispatch(showSetupSteps());
                }}
                className="NavBarUser__link"
                to={'/'}
              >
                Show Setup Steps
              </Link>
            </Menu.Item>
          )}
          {hiddenTipsUsage && (
            <Menu.Item>
              <button
                onClick={e => {
                  e.stopPropagation();
                  dispatch(showTipsAndUsage());
                }}
                className="NavBarUser__link"
              >
                Show Tips & Usage
              </button>
            </Menu.Item>
          )}

          <Menu.Item>
            <Link to="/settings" className="NavBarUser__link">
              Settings
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link onClick={logout} to="/auth" className="NavBarUser__link">
              Logout
            </Link>
          </Menu.Item>
        </Menu>
      </NavHoverMenu>
    </button>
  );
};
